import React, { createContext, useContext, useState, useCallback, useRef } from 'react';

const ToastContext = createContext();

// High-end, subtle UI notification sound
const NOTIFY_SOUND_URL = "https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3";

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);
  const audioRef = useRef(new Audio(NOTIFY_SOUND_URL));

  const addToast = useCallback((message, type = 'info') => {
    // Play Sound
    audioRef.current.currentTime = 0; // Reset to start if multiple trigger
    audioRef.current.volume = 0.4;   // Keep it subtle
    audioRef.current.play().catch(e => console.log("Audio play blocked until user interaction"));

    const id = Math.random().toString(36).substr(2, 9);
    setToasts((prev) => [...prev, { id, message, type }]);

    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, 4000);
  }, []);

  return (
    <ToastContext.Provider value={{ addToast }}>
      {children}
      
      {/* GLOBAL TOAST RENDERER */}
      <div className="fixed bottom-8 right-8 z-[999] flex flex-col gap-3 pointer-events-none">
        {toasts.map((t) => (
          <div 
            key={t.id}
            className="animate-in fade-in slide-in-from-right-10 duration-500 pointer-events-auto"
          >
            <div className={`
              px-6 py-4 rounded-2xl shadow-2xl border flex items-center gap-4 min-w-[320px] backdrop-blur-xl
              ${t.type === 'success' ? 'bg-blue-600/90 border-blue-400/50 shadow-blue-500/20' : 
                t.type === 'error' ? 'bg-red-600/90 border-red-400/50 shadow-red-500/20' : 
                'bg-slate-900/90 border-white/10 shadow-black/40'}
            `}>
              {/* Dynamic Icon/Dot based on type */}
              <div className="relative flex h-3 w-3">
                <span className={`animate-ping absolute inline-flex h-full w-full rounded-full opacity-75 ${t.type === 'error' ? 'bg-red-200' : 'bg-blue-200'}`}></span>
                <span className={`relative inline-flex rounded-full h-3 w-3 ${t.type === 'error' ? 'bg-white' : 'bg-blue-400'}`}></span>
              </div>

              <div>
                <p className="text-[9px] font-black uppercase tracking-[5px] opacity-60 text-white mb-0.5">
                  {t.type === 'success' ? 'System Success' : t.type === 'error' ? 'Attention' : 'Digitoly Cloud'}
                </p>
                <p className="text-sm font-bold text-white tracking-tight">{t.message}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);